import { DecimalPipe } from '@angular/common';
import { ChangeDetectorRef, Component, OnDestroy, OnInit, QueryList, ViewChildren} from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ModalDismissReasons, NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { GlobalSetting } from 'projects/Autofacets-Core/src/app/common-services/global-setting.service';
import { NgbdModalContent } from 'projects/Autofacets-Core/src/app/shared/delete-modal.component';
import { Constant } from 'projects/Autofacets-Core/src/app/utils/constant';
import { Utility } from 'projects/Autofacets-Core/src/app/utils/utility';
import { Observable, Subscription } from 'rxjs';
import { UserDataService } from 'src/app/DataServices/user-data.service';
import { BrandViewModel } from '../../../business-entities/brand-view-model';
import { Country, LocationCode } from '../../../business-entities/country.model';
import { DealerHolidayViewModel } from '../../../business-entities/dealer-holiday-list-view-model';
import { SelectListItemViewModel } from '../../../business-entities/select-list-item-view-model';
import { BrandService } from '../../../business-services/brand.service';
import { DealerBusinessService } from '../../../business-services/dealer.service';
import { CultureLocaleService } from '../../../services/culture-locale.service';
import { CustomPaggerService } from './../../../../../../Autofacets-Core/src/app/common-services/custom-pagger.service';
import * as fromEnums from './../../../../../../Autofacets-Core/src/app/utils/enums';
import { DealerBrandModel, DealerBrandViewModel } from './../../../business-entities/dealer-brand-view-model';
import { DealerDetailsListViewModel } from './../../../business-entities/dealer-details-view-model';
import { DealerOpeningHoursViewModel } from './../../../business-entities/dealer-opening-hours-view-model';
import { DealerServiceViewModel } from './../../../business-entities/dealer-service-view-model';
import { DealerConfigurationWaitingTime, DealerViewModel } from './../../../business-entities/dealer-view-model';
import { CityModel } from '../../../business-entities/customer-view.model';
import { CustomerService } from '../../../business-services/customer.service';
import { ToNumberPipe } from '../../../pipe/toNumber.pipe';
import { SecureStorage } from 'projects/Autofacets-Core/src/app/common-services/SecureStorage.service';
import { Features } from '../../../business-entities/user-role-view-model';
import { NgbdSortableHeader, SortEvent } from 'projects/Autofacets-Core/src/app/directives/sortable.directive';
import { CountryISO } from 'ngx-intl-tel-input-gg';
import { SettingService } from '../../../business-services/setting.service';

@Component({
  selector: 'app-edit-dealer',
  templateUrl: './edit-dealer.component.html',
  styleUrls: ['./edit-dealer.component.css']
})

export class EditDealerComponent implements OnInit, OnDestroy {
  @ViewChildren(NgbdSortableHeader) headers: QueryList<NgbdSortableHeader>;
  AddBrandInfo: DealerBrandModel =
    {
      brandCode: '',
      dealerId: '',
      description: '',
      brandName: '',
      logo: '',
      price:0,
      priceInclVat:0,
      isDisplayInWidget:false
    };
  deliveryTimeSlot: any = { hour: 0, minute: 0 };
  configurationArrivalTimes: DealerConfigurationWaitingTime[] = [];
  configurationWaitingTimes: DealerConfigurationWaitingTime[] = [];
  isBrandedit = false;
  dealerSelected: string;
  dealerList: SelectListItemViewModel[];
  selectedDealerId: string;
  dealerId: string;
  shiftTime: boolean;
  total$: Observable<number>;
  addDealerForm: FormGroup;
  dealerServiceForm: FormGroup;
  dealerBrandForm: FormGroup;
  dealerBasicDetails: boolean = true;
  dealerServiceDetails: boolean;
  dealerBrandDetails: boolean;
  dealerNotificationDetails: boolean;
  dealerServiceList: DealerServiceViewModel[];
  dealerAllBrands: DealerBrandViewModel[];
  dealerBrands: DealerBrandViewModel[] = [];
  dealerOpeningHours: DealerOpeningHoursViewModel[];
  dealerDetailsListViewModel: DealerDetailsListViewModel;
  dealerDetails: DealerViewModel;
  dealerServiceViewModel: DealerServiceViewModel;
  dealerHolidayDetails: boolean;
  dealerHoliday: any;
  form: FormGroup;
  countryDropdown: Country[] = [];
  locationDropdown: LocationCode[] = [];
  brandsSub: Subscription;
  holidaySub: Subscription;
  isDealerLoggedIn: boolean;
  brandList: BrandViewModel[];
  brands: BrandViewModel[]
  closeResult: string;
  popupCloseResult = false;
  userInputMobilecode?: string = '';
  deafultUserInputMobilecode?: string = '';
  userInputLandlinecode?: string = '';
  deafultUserInputLandlinecode?: string = '';
  isUnitPriceLengthError: boolean = false;
  isValidUnitPrice: boolean = false;
  postCodeList: any;
  postCodeRawData: any;
  cityList: CityModel[];
  countryName: string;
  countryList: any;
  isFormValid: boolean = false;
  features: Features[] = [];
  isShareBoxEnabled: boolean = false;
  showDealerSession: boolean = false;
  isDealerSessionIdError: boolean = false;
  isDealerSessionIdSet: boolean = false;
  isPickUpDropOff: boolean = false;
  featureList: Features[] = [];
  isShowTaxTab: boolean = false;
  isShowPriceInBrand: boolean = false;
  isShowLocationCode : boolean = false;
  CountryISO = CountryISO;
  isInitialLoad: boolean= true;
  isInitialLoadLandline: boolean= true;
  onlyCountries: string[] = [];
  countryDialCodes: any[]= [];
  selectedCountryISOMobile= this.cultureLocaleService.getLocale() || CountryISO.Norway;
  selectedCountryISOLandline= this.cultureLocaleService.getLocale() || CountryISO.Norway;
  transportSolutionList:{id: any, name: any}[] = [];
  selectedTransportSolutions:{id: any, name: any}[] = [];
  dropdownSettings: {};
  transportSolutionId:any = '';
  VATPercentage:number=0;
  isMg: boolean = false;
  constructor(
    private readonly formBuilder: FormBuilder,
    private readonly dealerBusinessService: DealerBusinessService,
    private readonly toastr: ToastrService,
    private readonly spinner: NgxSpinnerService,
    public pService: CustomPaggerService,
    private readonly brandService: BrandService,
    private readonly modalService: NgbModal,
    private readonly translate: TranslateService,
    private readonly userService: UserDataService,
    private readonly globalSetting: GlobalSetting,
    private readonly cultureLocaleService: CultureLocaleService,
    private readonly activeModal: NgbActiveModal,
    private readonly service: CustomerService,
    private readonly decimalPipe: DecimalPipe,
    private readonly secureStorage: SecureStorage,
    private readonly settingService: SettingService,
    private readonly cdref : ChangeDetectorRef
  ) {
    this.pService.pageSize = 10;
    this.pService.searchby = ['brandCode', 'brandName', 'description'];
    this.pService.searchTerm = '';
  }

  ngOnInit(): void {
    this.onlyCountries = this.settingService.onlyCountries;
    this.countryDialCodes = this.settingService.countryDialCodes;
    this.pService.dataSource = [];
    this.isShowLocationCode = localStorage.getItem("Theme") === 'bnh';
    this.isMg = localStorage.getItem("Theme") === 'mg';

    this.VATPercentage=this.secureStorage.getKeyData('VATPercentage');
    this.onAssignDefaultPrice(0);
    this.isDealerLoggedIn = this.userService.currentUserValue.roleType === fromEnums.UserRoles.DealerAdmin;
    this.dealerId = this.dealerBusinessService.dealerId;
    // Initialize transport solutions array
    this.selectedTransportSolutions = [];
    this.getFeatures();
    this.getBrands();
    this.initializeModel();
    this.getPostCodeDropdown();
    this.countryDropdownDetails();
    this.getCountries();
    this.getLocationCode();
    this.addDealerForm = this.formBuilder.group({
      name: ['', [Validators.required, Validators.pattern(/^(?!\s+$)/)]],
      address1: ['', [Validators.required]],
      address2: [''],
      city: [null, [Validators.required]],
      state: [''],
      country: [-1, (control: AbstractControl) => {
        if (control.value && +control.value > 0) {
          return null;
        }
        return { 'NotSelected': true };
      }],
      pincode: [null, [Validators.required]],
      landline: ['', [Validators.required]],
      mobile: [''],
      email: ['', [Validators.required, Validators.pattern(fromEnums.RegexKeyCollection.Email)]],
      isActive: [true],
      isActiveForWidget: [true],
      keyLocation: [false],
      onlinePayment: [false],
      vehiclePickupDropoffService: [false],
      dealershipsId: [0, this.isShowLocationCode ? [Validators.required] : null],
      franchiseId: [null],
      vatNumber: [null, [Validators.required]],
      // adUserId: [null],
      unitPrice: ['', Validators.required],
      customerWaitingLimit: ['', [Validators.required]],
      bankAccountNumber: ['', [Validators.maxLength(30)]],
      companyNumber: ['', [Validators.required, Validators.maxLength(30)]],
      dealerSessionId: [''],
      enableRentalCar: [false],
      leadTime: [0],
      rentalProvider: [0],
      rentalCarPrice: [0],
      enableDMS: [false],
      enableMenuPricing: [false],
      enableBookingNotification: [false],
      enableWaiting: [false],
      serviceAgreement: [false],
      kiosk: [false],
      realTimeBooking: [false],
      isCampaignPriceConsidered: [false],
      website: [null],
      dealerDmsNo: [null],
      latitude: [0],
      longitude: [0],
      noOfWeekInCalendar: [0],
      dealerDropInLink: [''],
      SsmDealerId: [''],
      SstDealerId: ['']
    });
    if (this.isMg) {
      this.addDealerForm.get('companyNumber').reset();
      this.addDealerForm.get('vatNumber').reset();
      this.addDealerForm.get('companyNumber').setErrors(null);
      this.addDealerForm.get('vatNumber').setErrors(null);
      this.addDealerForm.get('companyNumber').clearValidators();
      this.addDealerForm.get('vatNumber').clearValidators();
    }
    this.dropdownSettings = {
      singleSelection: false,
      idField: 'id',
      textField: 'name',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 3,
      allowSearchFilter: false,
      maxHeight: 700
    };
    this.telInputObject();
    this.telInputObjectForLandline();
    this.showHideDealerSession();
    this.loadTransportSolution();
  }

  async getFeatures() {
    if (this.secureStorage.getKeyData('feature')) {
      this.featureList = this.secureStorage.getKeyData('feature');
      if (this.featureList && this.featureList.length > 0) {
        this.isShowPriceInBrand = this.featureList.find(x => x.featureCode === fromEnums.FeatureCode.AllowDealerBrandLaborRate)?.isActive;
        this.isShowTaxTab = this.featureList.find(x => x.featureCode === fromEnums.FeatureCode.Tax)?.isActive;
        this.isPickUpDropOff = this.featureList.find(x => x.featureCode === fromEnums.FeatureCode.PickupDropoff)?.isActive;
        this.isShareBoxEnabled = this.featureList.find(x => x.featureCode === fromEnums.FeatureCode.ShareBox)?.isActive;
      }
    }
  }

  telInputObject() {
      if (this.userInputMobilecode) {
        const countryCode = this.getCountryCodeByDialCode(this.userInputMobilecode);
          this.selectedCountryISOMobile= countryCode ? countryCode : this.cultureLocaleService.getLocale();
      }
      else{
        this.selectedCountryISOMobile= this.cultureLocaleService.getLocale();
        this.deafultUserInputMobilecode = this.getDialCodeByCountryCode(this.selectedCountryISOMobile);
      }
  }

  getCountryCodeByDialCode(dialCode: any) {
    const country = this.countryDialCodes.find(c => c.dialCode === dialCode);
    return country ? country.countryCode : null;
  }
  getDialCodeByCountryCode(countryCode) {
    const country = this.countryDialCodes.find(c => c.countryCode === countryCode);
    return country ? country.dialCode : null;
  }
  mobileNumberChanged() {
    if ((this.userInputMobilecode === null || 
      this.userInputMobilecode === '' || 
      this.userInputMobilecode === undefined) 
      && this.deafultUserInputMobilecode) {
      this.userInputMobilecode = this.deafultUserInputMobilecode;
    }
  }

  async getLocationCode() {
    this.locationDropdown = await this.dealerBusinessService.getLocationCode();
  }

  onCountryChange(obj) {
    if (this.isInitialLoad) {
    this.telInputObject();
    this.userInputMobilecode = this.userInputMobilecode || obj.dialCode;
    this.isInitialLoad = false;
    } else {
      this.userInputMobilecode = obj.dialCode;
    }
  }

  telInputObjectForLandline() {
    if (this.userInputLandlinecode) {
      let countryCode = this.getCountryCodeByDialCode(this.userInputLandlinecode);
      this.selectedCountryISOLandline= countryCode ? countryCode : this.cultureLocaleService.getLocale();
    }
    else
    {
      this.selectedCountryISOLandline= this.cultureLocaleService.getLocale();
      this.deafultUserInputLandlinecode = this.getDialCodeByCountryCode(this.selectedCountryISOLandline);
    }
  }

  landlineNumberChanged() {
    if ((this.userInputLandlinecode === null || 
      this.userInputLandlinecode === '' || 
      this.userInputLandlinecode === undefined) 
      && this.deafultUserInputLandlinecode) {
      this.userInputLandlinecode = this.deafultUserInputLandlinecode;
    }
  }

  onCountryChangeForLandline(obj) {
    if (this.isInitialLoadLandline) {
    this.telInputObjectForLandline();
    this.userInputLandlinecode = this.userInputLandlinecode || obj.dialCode;
    this.isInitialLoadLandline = false;
    } else {
      this.userInputLandlinecode = obj.dialCode;
    }
  }

  onChangeUnitPrice(event) {
    const toNumberPipe = new ToNumberPipe();
    const formatted = this.decimalPipe.transform(toNumberPipe.transform(event.target.value), '1.2-2');
    this.addDealerForm.patchValue({ unitPrice: formatted });
  }
  initializeModel() {
    this.dealerDetails = {
      address1: '',
      address2: '',
      city: '',
      country: '-1',
      dealerId: '',
      email: '',
      id: 0,
      isActive: false,
      isActiveForWidget: false,
      landline: 0,
      mobile: 0,
      name: '',
      pincode: '',
      state: '',
      keyLocation: false,
      onlinePayment: false,
      vehiclePickupDropoffService: false,
      dealershipsId: 0,
      locationName : '',
      franchiseId: 0,
      //adUserId: '',
      unitPrice: '',
      customerWaitingLimit: 0,
      companyNumber: '',
      bankAccountNumber: '',
      vatNumber: '',
      dealerSessionId: '',
      enableRentalCar: false,
      leadTime: 0,
      rentalProvider: 0,
      rentalCarPrice: 0,
      enableDMS: false,
      enableMenuPricing: false,
      enableBookingNotification: false,
      enableWaiting: false,
      serviceAgreement: false,
      kiosk: false,
      realTimeBooking: false,
      isCampaignPriceConsidered: false,
      website: '',
      dealerDmsNo: '',
      latitude: 0,
      longitude: 0,
      noOfWeekInCalendar: 0,
      dealerDropInLink: '',
      ssmDealerId:'',
      sstDealerId:'',
      transportSolutionId:''
    };
    this.dealerDetailsListViewModel = {
      dealerDetails: {
        address1: '',
        address2: '',
        city: '',
        country: '',
        dealerId: '',
        email: '',
        id: 0,
        isActive: false,
        isActiveForWidget: false,
        landline: 0,
        mobile: 0,
        name: '',
        pincode: '',
        state: '',
        keyLocation: false,
        onlinePayment: false,
        vehiclePickupDropoffService: false,
        dealershipsId: 0,
        locationName : '',
        franchiseId: 0,
        // adUserId: '',
        unitPrice: '',
        customerWaitingLimit: 0,
        companyNumber: '',
        bankAccountNumber: '',
        landlineCode: '',
        vatNumber: '',
        dealerSessionId: '',
        enableRentalCar: false,
        leadTime: 0,
        rentalProvider: 0,
        rentalCarPrice: 0,
        enableDMS: false,
        enableMenuPricing: false,
        enableBookingNotification: false,
        enableWaiting: false,
        serviceAgreement: false,
        kiosk: false,
        realTimeBooking: false,
        isCampaignPriceConsidered: false,
        website: '',
        dealerDmsNo: '',
        latitude: 0,
        longitude: 0,
        noOfWeekInCalendar: 0,
        dealerDropInLink: '',
        ssmDealerId:'',
        sstDealerId:'',
        transportSolutionId:''
      },
      dealerBrandList: [],
      dealerHours: [],
      dealerServiceCategoryList: []
    };
  }
  getBrands() {
    this.brandService.getBrand().then(res => {
      if (res) {
        this.brandList = res;
        this.brands = res
      }
    }
    )
  }

  BindPostData(city) {
    if (city?.trim()) {
      this.postCodeList = this.postCodeRawData.filter(f => f.city?.toUpperCase() == city?.toUpperCase());
      if (!this.cpf.pincode.value || this.cpf.pincode.value?.length === 0) {
        this.dealerDetails.pincode = this.postCodeList[0]?.code;
        this.addDealerForm.patchValue({
          city: city,
          pincode: this.postCodeList[0]?.code
        })
      }
    } else {
      this.postCodeList = this.postCodeRawData;
    }
  }
  async onPostCodeSelected(postCode: string) {
    this.dealerDetails.pincode = postCode;
    if (postCode?.trim()) {
      this.BindCityData(postCode);
      this.BindCountry(postCode)
    } else {
      this.postCodeList = this.postCodeRawData;
      this.dealerDetails.city = this.cpf.city.value;
      this.addDealerForm.patchValue({
        country: -1,
        city: this.cpf.city.value,
        pincode: postCode
      })
      this.dealerDetails.country = '';
    }
  }
  BindCityData(post) {
    if (post?.trim()) {
      let postdata = this.postCodeRawData.filter(f => f.code == post);
      this.cityList = postdata.map(item => item.city).filter((value, index, self) => self.indexOf(value) === index);
      this.onCitySelected(this.cityList[0])
    } else {
      this.cityList = this.postCodeRawData.map(item => item.city).filter((value, index, self) => self.indexOf(value) === index);
    }
  }
  async onCitySelected(city: any) {
    this.dealerDetails.city = city;
    if (city?.trim()) {
      this.BindPostData(city);
      this.BindCountryBasedCity(city);
    } else {
      this.cityList = this.postCodeRawData.map(item => item.city).filter((value, index, self) => self.indexOf(value) === index);
      this.dealerDetails.pincode = null;
      this.addDealerForm.patchValue({
        country: '-1',
        city: city,
        pincode: null
      })
      this.dealerDetails.country = '';
    }
  }
  BindCountryBasedCity(city) {
    let postdata = this.postCodeRawData?.filter(f => f.city?.toUpperCase() == city?.toUpperCase())
    let countryCode =postdata?.map(item => item.countryCode)?.filter((value, index, self) => self.indexOf(value) === index);
    let selectedCountry=this.countryList?.filter(f=>f.code?.toUpperCase() === countryCode[0]?.toUpperCase())
    this.countryName = selectedCountry[0]?.countryName;
    this.addDealerForm.patchValue({ country: selectedCountry[0]?.id });
  }
  getPostCodeDropdown() {
    this.spinner.show();
    let postCodes = this.secureStorage.getKeyData('postCodes');
    if (postCodes) {
      this.postCodeRawData = postCodes;
      this.BindPostData("");
      this.BindCityData("");
    } 
    this.spinner.hide();
  }
 BindCountry(postCode)
   {
     let postdata = this.postCodeRawData.filter(f => f.code == postCode);
     let countryCode =postdata.map(item => item.countryCode).filter((value, index, self) => self.indexOf(value) === index);
     let selectedCountry=this.countryList.filter(f=>f.code?.toUpperCase() === countryCode[0]?.toUpperCase());
     const countryId = (selectedCountry[0]?.id) != undefined ? selectedCountry[0]?.id : 0;
     this.addDealerForm.patchValue({ country: countryId });
   }
    countryDropdownDetails(){
     this.service.getCountryCodeAndMobileCodeDetails()
      .then((response) => {
        this.countryList = response?.responseObject?.result.filter(x => x.isDisplay);
      },_error => {
        this.spinner.hide();
      });
  }

  checkLength(event): void {
    if (event.target.value) {
      let inputValue = event.target.value.toString().trim().replace(/^0+/, '');
      if (inputValue.toString().includes(',') || /\s/.test(inputValue)) {
        if (inputValue.split(",").length - 1 > 1) {
          this.isValidUnitPrice = true;
        }
        else if (inputValue.toString().includes('.') && inputValue.toString().includes(',')) {
          this.isValidUnitPrice = true;
        }
        else {
          this.isValidUnitPrice = false;
          let splitedValue = inputValue.toString().split(',');
          let val = splitedValue[0].replace(/\s/g, '');
          this.isUnitPriceLengthError = val.length > 6 ? true : false;
        }
      } else if (inputValue.toString().includes('.')) {
        if (inputValue.split(".").length - 1 > 1) {
          this.isValidUnitPrice = true;
        }
        else if (inputValue.toString().includes('.') && inputValue.toString().includes(',')) {
          this.isValidUnitPrice = true;
        }
        else {
          this.isValidUnitPrice = false;
          let splitedValue = inputValue.toString().split('.');
          let val = splitedValue[0].replace(/\s/g, '');
          this.isUnitPriceLengthError = val.length > 6 ? true : false;
        }
      }
      else {
        this.isValidUnitPrice = false;
        this.isUnitPriceLengthError = inputValue.length > 6 ? true : false;
      }

    }
  }

  getBrandImage(key: any) {
    return this.brandList.filter(x => x.brandCode.toUpperCase() === key.toUpperCase())[0].image
  }
  getCountries() {
    this.dealerBusinessService.getAllCountries().then((res)=>{
      this.countryDropdown = res;
      if (this.countryDropdown && this.countryDropdown.length > 0) {
        this.getDealerDetails(this.dealerId);
      }
    });
  }
  deleteBrand(brandInfo: DealerBrandViewModel) {
    brandInfo.dealerId = this.dealerId
    let modelHeadermsg = this.translate.instant('lblDelete');
    let modelBodymsg = Utility.createMessage(this.translate.instant("lblSureToDelete"), this.translate.instant("lblDealerBrands"), true);
    const modalRef = this.modalService.open(NgbdModalContent);
    modalRef.componentInstance.modelHeader = modelHeadermsg;
    modalRef.componentInstance.modelBody = modelBodymsg;
    modalRef.result.then(
      _result => {
        // This is intentional
       },
      reason => {
        this.popupCloseResult = this.deleteDismissReason(reason);
        if (this.popupCloseResult) {
          this.spinner.show()
          this.dealerBusinessService.deleteDealerBrand(brandInfo).then(response => {
            if (response.responseCode == Constant.SuccessResponseCode) {
              let deletedmsg = this.translate.instant('lblDeletedBrand');
              this.toastr.success(deletedmsg);
              this.dealerAllBrands = this.dealerAllBrands.filter(x => x.brandCode.toUpperCase() !== brandInfo.brandCode.toUpperCase());
              this.addDealerBrandsPagination()
            }
          });
          this.spinner.hide()
        }
      }
    );
  }
  AddBrand(brandInfo: DealerBrandViewModel) {
    this.spinner.show();
    brandInfo.dealerId = this.dealerId
    let addedMsg = this.translate.instant('lblDealerBrandAdded');
    let notaddedMsg = this.translate.instant('lblDealerBrandAlreadyadded');
    let editMsg = this.translate.instant('lblDealerBrandEdited');
    let noteditMsg = this.translate.instant('lblDealerBrandNotEdited');
    if (this.isBrandedit === false) {
      this.dealerBusinessService.addDealerBrand(brandInfo).then((res) => {
        if (res.responseObject) {
          let model: DealerBrandViewModel = { logo: '', id: 0, brandCode: '', brandName: '', dealerId: '', description: '',price: 0,priceInclVat: 0,isDisplayInWidget:false }
          model.description = brandInfo.description
          model.brandCode = brandInfo.brandCode
          model.price = brandInfo.price
          model.priceInclVat = brandInfo.priceInclVat
          model.isDisplayInWidget = brandInfo.isDisplayInWidget
          model.dealerId = this.dealerId
          let brands = [...this.brandList]
          let brand = brands.filter(x => x.brandCode.toUpperCase() === brandInfo.brandCode.toUpperCase())[0]
          model.logo = brand.image && typeof brand.image === 'string' ? brand.image : "";
          model.brandName = brand.brandName
          if ( model?.brandName !== null) {
            this.dealerAllBrands.push(model)
            this.addDealerBrandsPagination()
          }
          this.AddBrandInfo.brandCode = ''
          this.AddBrandInfo.description = ''
          this.onAssignDefaultPrice(0);
          this.toastr.success(addedMsg)
        }
        else {
          this.toastr.warning(notaddedMsg)
        }
        document.getElementById("modelButton").click();
      }
      )
    }
    if (this.isBrandedit === true) {
      this.dealerBusinessService.editDealerBrand(brandInfo).then((res) => {
        if (res.responseObject === 1) {
          this.dealerAllBrands.forEach(element => {
            if (element.brandCode === brandInfo.brandCode){
              element.description = brandInfo.description
              element.price = brandInfo.price
              element.priceInclVat = brandInfo.priceInclVat
              element.isDisplayInWidget = brandInfo.isDisplayInWidget
            } 
          });
          this.addDealerBrandsPagination()
          this.toastr.success(editMsg)
        }
        else {
          this.toastr.error(noteditMsg)
        }
      })
      document.getElementById("modelButton").click();
    }
    this.spinner.hide()
  }
  async getDealerDetails(dealerId: string) {
    this.spinner.show();
    await this.dealerBusinessService.getDealerDetails(dealerId).then((response) => {
      this.dealerDetailsListViewModel = response;
      this.dealerDetails = this.dealerDetailsListViewModel.dealerDetails;
      const dealershipsId = this.dealerDetails.dealershipsId;
      const dealerLocationName = this.dealerDetails.locationName;
      const dealerLocationCodeName = `${dealershipsId} - ${dealerLocationName}`;
      this.addDealerForm.patchValue({
        name: this.dealerDetails.name,
        companyNumber: this.dealerDetails.companyNumber,
        address1: this.dealerDetails.address1,
        address2: this.dealerDetails.address2,
        dealershipsId: dealerLocationCodeName,
        franchiseId: this.dealerDetails.franchiseId == 0 ? '' : this.dealerDetails.franchiseId,
        vatNumber: this.dealerDetails.vatNumber,
        bankAccountNumber: this.dealerDetails.bankAccountNumber,
        //country: this.dealerDetails.country,
        customerWaitingLimit: this.dealerDetails.customerWaitingLimit,
        email: this.dealerDetails.email,
        isActive: this.dealerDetails.isActive,
        isActiveForWidget: this.dealerDetails.isActiveForWidget,
        keyLocation: this.dealerDetails.keyLocation,
        onlinePayment: this.dealerDetails.onlinePayment,
        vehiclePickupDropoffService: this.dealerDetails.vehiclePickupDropoffService,
        city: this.dealerDetails?.city,
        pincode: this.dealerDetails?.pincode,
        dealerSessionId: this.dealerDetails.dealerSessionId,
        enableRentalCar: this.dealerDetails.enableRentalCar,
        leadTime: this.dealerDetails.leadTime,
        rentalProvider: this.dealerDetails.rentalProvider,
        rentalCarPrice: this.dealerDetails.rentalCarPrice,
        enableDMS: this.dealerDetails.enableDMS,
        enableMenuPricing: this.dealerDetails.enableMenuPricing,
        enableBookingNotification: this.dealerDetails.enableBookingNotification,
        enableWaiting: this.dealerDetails.enableWaiting,
        serviceAgreement: this.dealerDetails.serviceAgreement,
        kiosk: this.dealerDetails.kiosk,
        realTimeBooking: this.dealerDetails.realTimeBooking,
        isCampaignPriceConsidered: this.dealerDetails.isCampaignPriceConsidered,
        website: this.dealerDetails.website,
        dealerDmsNo: this.dealerDetails.dealerDmsNo,
        latitude: this.dealerDetails.latitude,
        longitude: this.dealerDetails.longitude,
        noOfWeekInCalendar: this.dealerDetails.noOfWeekInCalendar,
        SsmDealerId: this.dealerDetails.ssmDealerId,
          SstDealerId: this.dealerDetails.sstDealerId,
          dealerDropInLink: this.dealerDetails.dealerDropInLink
      });
      this.configurationArrivalTimes = this.sortTimeSlots(this.dealerDetails.configurationArrivalTimes) ?? [];
      this.configurationWaitingTimes = this.sortTimeSlots(this.dealerDetails.configurationWaitingTimes) ?? [];
        if (this.dealerDetails.dealerSessionId && this.dealerDetails.dealerDropInLink) {
        this.isDealerSessionIdSet = true;
      }
      if (this.dealerDetails.unitPrice!==null || this.dealerDetails.unitPrice!==undefined) 
      {
        const toNumberPipe = new ToNumberPipe();
        const formatted = this.decimalPipe.transform(toNumberPipe.transform(this.dealerDetails.unitPrice), '1.2-2');
        this.addDealerForm.patchValue({ unitPrice: formatted });
      }
      this.dealerAllBrands = this.dealerDetailsListViewModel.dealerBrandList;
      this.dealerOpeningHours = this.dealerDetailsListViewModel.dealerHours;
      if (this.dealerDetailsListViewModel.dealerDetails.mobileCode !== null && this.dealerDetailsListViewModel.dealerDetails.mobileCode !== '0') {
        this.userInputMobilecode = this.dealerDetailsListViewModel.dealerDetails.mobileCode;
      }
      this.telInputObject();
      if (this.dealerDetailsListViewModel.dealerDetails.landlineCode !== null && this.dealerDetailsListViewModel.dealerDetails.landlineCode !== '0') {
        this.userInputLandlinecode = this.dealerDetailsListViewModel.dealerDetails.landlineCode;
      }
      this.telInputObjectForLandline();
      if (this.dealerDetails.country) {
        let countryOfDealer = this.countryList.find(country => country.countryName === this.dealerDetails.country);
        this.dealerDetails.country = countryOfDealer ? countryOfDealer.id.toString() : '-1';
        this.addDealerForm.patchValue({ country: this.dealerDetails.country });
      } else {
        this.dealerDetails.country = '-1';
        this.addDealerForm.patchValue({ country: this.dealerDetails.country });
      }
      if (this.dealerDetails.mobile === 0) {
        this.addDealerForm.controls['mobile'].setValue('');
      }
      else {
        this.addDealerForm.controls['mobile'].setValue(this.dealerDetails.mobile);
      }
      if (this.dealerDetails.landline === 0) {
        this.addDealerForm.controls['landline'].setValue('');
      }
      else {
        this.addDealerForm.controls['landline'].setValue(this.dealerDetails.landline);
      }
      
      if (this.dealerDetails.transportSolutionId) {
        this.transportSolutionId = this.dealerDetails.transportSolutionId;
        const selectedIds = this.dealerDetails.transportSolutionId.split(',');
        this.selectedTransportSolutions = [];
        selectedIds.forEach(id => {
          if (id.trim()) {
            const transportSolution = this.transportSolutionList.find(t => t.id.toString() === id.trim());
            if (transportSolution) {
              this.selectedTransportSolutions.push(transportSolution);
            }
            this.onChangeTransportSolution(id.trim(), true, true);
          }
        });
      }

      this.spinner.hide();
      this.showHideDealerSession();
    });
  }

  openEdit(content, data) {

    this.isBrandedit = true
    this.AddBrandInfo.brandCode = data.brandCode
    this.AddBrandInfo.description = data.description
    this.AddBrandInfo.price = data.price
    this.AddBrandInfo.priceInclVat = data.priceInclVat
    this.AddBrandInfo.isDisplayInWidget = data.isDisplayInWidget
    this.modalService.open(content, { ariaLabelledBy: 'modal-basic-title' }).result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }
  open(content) {
    this.isBrandedit = false
    this.AddBrandInfo.brandCode = ''
    this.AddBrandInfo.description = ''
    this.onAssignDefaultPrice(0);     

    this.modalService.open(content, { ariaLabelledBy: 'modal-basic-title' }).result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }

  private deleteDismissReason(reason: any): boolean {
    if (reason === ModalDismissReasons.ESC) {
      return false;
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return false;
    } else {
      return reason;
    }
  }
  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }
  get cpf() {
    return this.addDealerForm.controls;
  }

  changeTab(event) {
    this.pService.dataSource = [];
    if (event.nextId == '0') {
      this.dealerBasicDetails = true;
      this.dealerServiceDetails = false;
      this.dealerBrandDetails = false;
      this.dealerHolidayDetails = false;
      this.dealerNotificationDetails = false;
      this.unSubscribeBrandsSubscription();
      this.unSubscribeHolidaySubscription();
    }
    else if (event.nextId == '2') {
      this.unSubscribeHolidaySubscription();
      this.dealerBasicDetails = false;
      this.dealerServiceDetails = false;
      this.dealerBrandDetails = true;
      this.dealerHolidayDetails = false;
      this.dealerNotificationDetails = false;
      this.addDealerBrandsPagination();
    }
    else if (event.nextId == '3') {
      this.unSubscribeBrandsSubscription();
      this.getDealerWiseHolidayList(this.dealerId);
      this.dealerHolidayDetails = true;
      this.dealerBasicDetails = false;
      this.dealerServiceDetails = false;
      this.dealerBrandDetails = false;
      this.dealerNotificationDetails = false;
    }
  }
  addDealerBrandsPagination() {
    this.spinner.show();
    this.pService.dataSource = this.dealerAllBrands;
    this.brandsSub = this.pService.dealers$.subscribe(brands => {
      this.dealerBrands = brands.map((brand, index: number) => { return { ...brand, row: this.currentPageNumber(index) } });
      this.spinner.hide();
    })
  }

  async getDealerWiseHolidayList(dealerId: string) {
    this.spinner.show();
    this.dealerBusinessService.getDealerWiseHolidayList(dealerId).then((response) => {
      this.pService.dataSource = response;
      this.holidaySub = this.pService.dealers$.subscribe((holidays) => {
        this.dealerHoliday = this.dealerHolidayDataMapper(holidays);
      });
      this.spinner.hide();
    },() => {
      this.spinner.hide()
    });

  }
  
  onSort({ column, direction }: SortEvent) {
    // resetting other headers
    this.headers.forEach(header => {
      if (header.sortable !== column) {
        header.direction = '';
      }
    });

    this.pService.sortColumn = column;
    this.pService.sortDirection = direction;
  }

  isDigit(event): void {
    const isDigit = Utility.isDigit(event);
    if (!isDigit) {
      event.preventDefault();
    }
  }

  private dealerHolidayDataMapper(holiday: DealerHolidayViewModel[]) {
    let supperArray = [];
    if (holiday && holiday.length > 0) {

      for (let index = 0; index < holiday.length; index++) {
        const element = holiday[index];

        const single = Object();
        single.rowNumber = this.currentPageNumber(index);
        single.id = element.id;
        single.name = element.name;
        single.endDate = element.endDate;
        single.startDate = element.startDate;

        supperArray.push(single);
      }
    }

    return supperArray;
  }

  private currentPageNumber(cIndex: number): number {
    let rtPageNumber = 0;
    if (this.pService.page === 1) {
      rtPageNumber = cIndex + 1;
    }
    else if (this.pService.page > 1) {
      rtPageNumber = Number.parseInt(`${(this.pService.pageSize * (this.pService.page - 1))}`) + (cIndex + 1);
    }

    return rtPageNumber;
  }

  onSubmit(isSaveAndClose): void {
    if (this.addDealerForm.invalid || this.isDealerSessionIdError) {
      return;
    }
    this.isDealerSessionIdSet = true;
    if(!this.cpf.keyLocation.value){
      this.addDealerForm.get('dealerSessionId').reset();  
      this.addDealerForm.get('dealerSessionId').setErrors(null);        
      this.addDealerForm.get('dealerDropInLink').reset();  
      this.addDealerForm.get('dealerDropInLink').setErrors(null);  
      this.isDealerSessionIdSet = false;
      this.isDealerSessionIdError = false;
    }
    let mobileNo= this.addDealerForm.controls.mobile.value?.number ? this.addDealerForm.controls.mobile.value.number.toString().replace(/\s+/g, '') : this.addDealerForm.controls.mobile.value;
    let landlineNo= this.addDealerForm.controls.landline.value?.number ? this.addDealerForm.controls.landline.value.number.toString().replace(/\s+/g, '') : this.addDealerForm.controls.landline.value;
    this.dealerDetails.pincode = this.addDealerForm.controls.pincode.value;
    this.dealerDetails.city = this.addDealerForm.controls.city.value;
    this.dealerDetails.unitPrice = this.cpf.unitPrice.value !== null ? this.globalSetting.getFormattedprice(this.cpf.unitPrice.value.toString().trim()) : this.cpf.unitPrice.value;
    this.dealerDetails.isActive = this.addDealerForm.controls["isActive"].value;
    this.dealerDetails.isActiveForWidget = this.addDealerForm.controls["isActiveForWidget"].value;
    this.dealerDetails.keyLocation = this.addDealerForm.controls["keyLocation"].value;
    this.dealerDetails.onlinePayment = this.addDealerForm.controls["onlinePayment"].value;
    this.dealerDetails.vehiclePickupDropoffService = this.addDealerForm.controls["vehiclePickupDropoffService"].value;
    this.dealerDetails.companyNumber = this.addDealerForm.controls["companyNumber"].value;
    this.dealerDetails.address1 = this.addDealerForm.controls["address1"].value;
    this.dealerDetails.address2 = this.addDealerForm.controls["address2"].value;
    this.dealerDetails.franchiseId = Number(this.addDealerForm.controls["franchiseId"].value);
    this.dealerDetails.vatNumber = this.addDealerForm.controls["vatNumber"].value;
    this.dealerDetails.bankAccountNumber = this.addDealerForm.controls["bankAccountNumber"].value;
    this.dealerDetails.customerWaitingLimit = this.addDealerForm.controls["customerWaitingLimit"].value;
    this.dealerDetails.email = this.addDealerForm.controls["email"].value;
    this.dealerDetails.country = this.addDealerForm.controls["country"].value;
	  this.dealerDetails.dealerSessionId = this.cpf.keyLocation.value ? this.cpf.dealerSessionId.value : '';
    this.dealerDetails.dealerDropInLink = this.cpf.keyLocation.value ? this.cpf.dealerDropInLink.value : '';
    this.dealerDetails.enableRentalCar = this.cpf.enableRentalCar.value;
    this.dealerDetails.leadTime = this.cpf.leadTime.value;
    this.dealerDetails.rentalProvider = this.cpf.rentalProvider.value;
    this.dealerDetails.rentalCarPrice = this.cpf.rentalCarPrice.value;
    this.dealerDetails.enableDMS = this.cpf.enableDMS.value;
    this.dealerDetails.enableMenuPricing = this.cpf.enableMenuPricing.value;
    this.dealerDetails.enableBookingNotification = this.cpf.enableBookingNotification.value;
    this.dealerDetails.enableWaiting = this.cpf.enableWaiting.value;
    this.dealerDetails.serviceAgreement = this.cpf.serviceAgreement.value;
    this.dealerDetails.kiosk = this.cpf.kiosk.value;
    this.dealerDetails.realTimeBooking = this.cpf.realTimeBooking.value;
    this.dealerDetails.isCampaignPriceConsidered = this.cpf.isCampaignPriceConsidered.value;
    this.dealerDetails.website = this.cpf.website.value;
    this.dealerDetails.dealerDmsNo = this.cpf.dealerDmsNo.value;
    this.dealerDetails.latitude = this.cpf.latitude.value;
    this.dealerDetails.longitude = this.cpf.longitude.value;
    this.dealerDetails.noOfWeekInCalendar = this.cpf.noOfWeekInCalendar.value;
    this.dealerDetails.configurationArrivalTimes = this.configurationArrivalTimes;
    this.dealerDetails.configurationWaitingTimes = this.configurationWaitingTimes;
    this.dealerDetails.transportSolutionId = this.transportSolutionId;
    const viewModel = { ...this.dealerDetails, email: this.dealerDetails.email.toLowerCase() ,
      mobile:parseInt(mobileNo),
      mobileCode:mobileNo!="" ? this.userInputMobilecode:"",
      landline:parseInt(landlineNo),
      landlineCode:landlineNo!=""? this.userInputLandlinecode :"",
      name:this.addDealerForm.value.name.trim()

    };
    this.spinner.show();
    this.dealerBusinessService.updateDealer(viewModel).then((response) => {
      let result = response.responseObject;
      this.spinner.hide();
      let userLimitError = this.translate.instant('lblDealerCreationLimitExceed');
      if (result) {
        if (result.errorCount && result.errorCount > 0) {
          let errorResponse = result.result;
          if (errorResponse.errorCode == fromEnums.ErrorCodes.AlreadyExist) {
            let errorMessage = this.translate.instant(errorResponse.errorMessage);
            this.toastr.error(errorMessage);
          }
          else if (errorResponse.errorCode == fromEnums.ErrorCodes.UserCreationLimitExceed) {
            this.toastr.error(userLimitError);
          }
        } else {
          this.toastr.success(fromEnums.ToastrMessages.DealerEdit);
          if(isSaveAndClose)
            this.activeModal.close({ success: true });
        }
      } else {
        this.toastr.error(fromEnums.ToastrMessages.DealerEditFailed);
      }
      
           
    });
  }

  unSubscribeBrandsSubscription() {
    this.pService.dataSource = [];
    if (this.brandsSub) this.brandsSub.unsubscribe();
  }

  unSubscribeHolidaySubscription() {
    this.pService.dataSource = [];
    if (this.holidaySub) this.holidaySub.unsubscribe();
  }

  showHideDealerSession() {
    this.showDealerSession = false;
    if (this.cpf.keyLocation.value && this.isShareBoxEnabled) {
      this.showDealerSession = true;
      this.addDealerForm.get('dealerSessionId').setValidators([Validators.required]);
      this.addDealerForm.get('dealerDropInLink').setValidators([Validators.required]);
    }
    else if(!this.cpf.keyLocation.value && this.isShareBoxEnabled){
      if(this.isDealerSessionIdError){
        this.addDealerForm.get('dealerSessionId').reset();      
        this.addDealerForm.get('dealerDropInLink').reset();    
      }
      this.addDealerForm.get('dealerSessionId').setErrors(null);       
      this.addDealerForm.get('dealerDropInLink').setErrors(null);   
      this.isDealerSessionIdError = false;
    }
  }

  validateDealerSessionId() {
    this.isDealerSessionIdError = false;
    // if (this.cpf.dealerSessionId != null) {
    //   let regexp = /'^[{]?[0-9a-fA-F]{8}-([0-9a-fA-F]{4}-){3}[0-9a-fA-F]{12}[}]?$'/;
    //   let testId = regexp.test(this.cpf.dealerSessionId.value.toString());
    //   this.isDealerSessionIdError = testId ? false : true;
    // }
  }

  ngOnDestroy() {
    this.unSubscribeBrandsSubscription();
    this.unSubscribeHolidaySubscription();
  }

  OnClose() {
    this.activeModal.close({ success: true });
  }

  onBlur(event) {
    let price= this.globalSetting.getFormattedprice(JSON.parse(JSON.stringify(event.target.value)));
    this.onAssignDefaultPrice(price);
  }
 
  onAssignDefaultPrice(price){
    this.AddBrandInfo.price = 0;
    this.AddBrandInfo.priceInclVat = 0;
    if(this.isShowPriceInBrand){
      this.AddBrandInfo.price = price > 0? price : parseFloat(this.secureStorage.getKeyData('LaborUnitPrice'));
      let priceInclVAT = Utility.GetPriceInludingVAT(this.AddBrandInfo.price,this.VATPercentage);
      this.AddBrandInfo.priceInclVat = priceInclVAT; 
    }
  }

  onTimeSlotAdd() {
    if (this.deliveryTimeSlot && (this.deliveryTimeSlot.hour > 0 || this.deliveryTimeSlot.minute > 0)) {
      const timeSlotString =  (this.deliveryTimeSlot.hour < 10 ? '0' : '') + this.deliveryTimeSlot.hour.toString() + ':' + (this.deliveryTimeSlot.minute < 10 ? '0' : '') + this.deliveryTimeSlot.minute.toString();
      let duplicateRecordIndex = this.configurationArrivalTimes?.findIndex(x => x.timeSlot === timeSlotString);
      if (duplicateRecordIndex < 0) {
        let timeSlotDetail: DealerConfigurationWaitingTime = {
          dealerId : null,
          timeSlot : timeSlotString,
          timeSlotId: 0,
          timeSlotType: 2
        }
        this.configurationArrivalTimes.push(timeSlotDetail);
        this.configurationArrivalTimes = this.sortTimeSlots(this.configurationArrivalTimes);
        this.deliveryTimeSlot = { hour: 0, minute: 0 };
      }
      else{
        this.deliveryTimeSlot = { hour: 0, minute: 0 };
        let dealerSlotExists = this.translate.instant('lblDealerSlotAlreadyExist');
        this.toastr.error(dealerSlotExists);
      }
    }
  }  

  onTimeSlotDelete(timeSlot) {
    this.configurationArrivalTimes = this.configurationArrivalTimes?.filter(x => x.timeSlot !== timeSlot);
  }

  sortTimeSlots(slots: DealerConfigurationWaitingTime[]): DealerConfigurationWaitingTime[] {
    return slots?.sort((a, b) => {
      const timeA = new Date(`1970-01-01T${a.timeSlot}:00`);
      const timeB = new Date(`1970-01-01T${b.timeSlot}:00`);
      return timeA.getTime() - timeB.getTime();
    });
  }
  onMobileChange(){
    if(this.addDealerForm.get('mobile').value){
      let len= this.addDealerForm.get('mobile').value.number.toString().replace(/\s+/g, '').length;
      if(len<6 || len>11){
        this.addDealerForm.get('mobile').setValidators([Validators.pattern(/^\d{6,11}$/)]);
        this.addDealerForm.get('mobile').updateValueAndValidity();
      } else {
        this.addDealerForm.get('mobile').setValidators([]);
        this.addDealerForm.get('mobile').updateValueAndValidity();
      }
    }
  }
  onLandlineChange(){
    if(this.addDealerForm.get('landline').value){
      let len= this.addDealerForm.get('landline').value.number.toString().replace(/\s+/g, '').length;
      if(len<6 || len>11){
        this.addDealerForm.get('landline').setValidators([Validators.required, Validators.pattern(/^\d{6,11}$/)]);
        this.addDealerForm.get('landline').updateValueAndValidity();
      } else {
        this.addDealerForm.get('landline').setValidators([Validators.required]);
        this.addDealerForm.get('landline').updateValueAndValidity();
      }
    }
  }

  onChangeTransportSolution(event:any,isSelected:boolean,isLoadFromEdit:boolean){
    const eventId = isLoadFromEdit ? event : event.id.toString();
    if(isSelected){
      const existingIds = this.transportSolutionId ? this.transportSolutionId.split(',') : [];
      if (!existingIds.includes(eventId)) {
        this.transportSolutionId = this.transportSolutionId ? (this.transportSolutionId + ',' + eventId) : eventId;
      }
      if (!isLoadFromEdit) {
        const exists = this.selectedTransportSolutions.find(item => item.id === event.id);
        if (!exists) {
          this.selectedTransportSolutions.push(event);
        }
      }
    }
    else{
      const transportSolution = this.transportSolutionId.split(',');
      this.transportSolutionId = transportSolution.filter(cn => cn !== eventId).join(',');
      this.selectedTransportSolutions = this.selectedTransportSolutions.filter(item => item.id.toString() !== eventId);
    }
    if(isLoadFromEdit){
      this.cdref.detectChanges();
    }
  }

  onAllTransportSolution(isSelected: boolean) {
    if(isSelected)
    {
      this.selectedTransportSolutions = [...this.transportSolutionList];
      this.transportSolutionId = this.transportSolutionList.map(element => element.id.toString()).join(',');
    }
    else{
      this.selectedTransportSolutions = [];
      this.transportSolutionId = '';
    }
  }

  loadTransportSolution(){
    this.transportSolutionList.push({
      id:1,
      name:this.translate.instant('lblWishNoTransport')
    });
    this.transportSolutionList.push({
      id:2,
      name:this.translate.instant('lblWishTransportTicket')
    });
    this.transportSolutionList.push({
      id:3,
      name:this.translate.instant('lblAvailRentalCar')
    });
  }
}
